<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" :class="[`${prefix}-icon`, `${prefix}-icon-userUpload`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_aa36f6d2b3__a"><rect width="14" height="14" rx="7"/></clipPath></defs><g clip-path="url(#svg_aa36f6d2b3__a)"><rect width="14" height="14" rx="7" :fill="useCurrentColor ? 'currentColor' : '#2FDBBE'"/><path d="M3.25,9.875L10.75,9.875L10.75,10.75L3.25,10.75L3.25,9.875ZM9.151250000000001,5.24831L7.42763,3.430563C7.32069,3.321125,7.16969,3.25,7,3.25C6.83031,3.25,6.67938,3.321125,6.57419,3.431688L4.84694,5.247C4.75681,5.34487,4.69938,5.47131,4.69938,5.6114999999999995C4.69938,5.91244,4.957,6.15644,5.27456,6.15644C5.279,6.15644,5.28331,6.15588,5.28769,6.155749999999999L5.28769,6.159190000000001L6.0625,6.159190000000001L6.0625,9.15456L7.9375,9.15456L7.9375,6.159190000000001L8.69131,6.159190000000001L8.69131,6.1548099999999994C8.70269,6.1554400000000005,8.71387,6.15656,8.7255,6.15656C9.04312,6.15656,9.30069,5.9125,9.30069,5.6114999999999995C9.30069,5.47131,9.24319,5.344939999999999,9.151250000000001,5.24831Z" :fill="useCurrentColor ? 'currentColor' : '#FFF'"/></g></svg>
</template>
<script>

export default {
  name: 'IconUserUpload',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
